import React from "react"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs"
import { RFValue } from "react-native-responsive-fontsize"
import Social from "@Screens/Knowledge/SavoirFaire/Social/Social"
import Ateliers from "@Screens/Knowledge/SavoirFaire/Ateliers/Ateliers"
import Medias from "@Screens/Knowledge/SavoirFaire/Medias/Medias"
import Evaluation from "@Screens/Knowledge/Savoirs/Evaluation/Evaluation"

const Tab = createMaterialTopTabNavigator()

const SavoirFaireTopTabStack = () => {
    const screens = [
        // {
        //     tabBarLabel: "Social",
        //     name: "Social",
        //     component: Social
        // },
        {
            tabBarLabel: "Ateliers",
            name: "Ateliers",
            component: Ateliers
        },
        {
            tabBarLabel: "Médias",
            name: "Medias",
            component: Medias
        },
        {
            tabBarLabel: "Évaluation",
            name: "Evaluation",
            component: Evaluation
        }
    ]

    const screenOptions = {
        tabBarPressColor: baseColors.green.primary,
        tabBarActiveTintColor: baseColors.green.primary,
        tabBarInactiveTintColor: baseColors.black,
        tabBarScrollEnabled: true,
        tabBarItemStyle: { width: "auto" },
        tabBarLabelStyle: {
            fontSize: RFValue(14),
            fontFamily: baseFontFamily.OpenSansBold
        },
        tabBarIndicatorStyle: { backgroundColor: baseColors.green.primary, height: RFValue(4) }
    }

    return (
        <Tab.Navigator screenOptions={screenOptions}>
            {screens.map((item, i) => (
                <Tab.Screen
                    key={i}
                    name={item.name}
                    options={{ tabBarLabel: item.tabBarLabel }}
                    component={item.component}
                />
            ))}
        </Tab.Navigator>
    )
}

export default SavoirFaireTopTabStack
